
import { defineComponent, onBeforeMount, Ref, ref } from "vue";
import { useRoute } from "vue-router";

type Tab = {
  name: string;
  isActive: boolean;
};

export default defineComponent({
  name: "ContentTabMenu",
  emits: ["selectedTab"],
  setup(props, { emit }) {
    const route = useRoute();

    onBeforeMount(async () => {
      if (route.query.notification) {
        selectTab({ name: "Dúvidas", isActive: true });
      } else {
        selectTab({ name: "Avaliações", isActive: true });
      }
    });

    const tabs: Ref<Tab[]> = ref([
      { name: "Avaliações", isActive: false },
      { name: "Dúvidas", isActive: false }
    ]);

    const selectTab = (selectedTab: Tab) => {
      setIsActive(selectedTab);
      emit("selectedTab", selectedTab.name);
    };

    const setIsActive = (selectedTab: Tab) => {
      tabs.value.forEach((tab: Tab) => {
        tab.isActive = tab.name === selectedTab.name;
      });
    };

    return {
      tabs,
      selectTab
    };
  }
});
